export enum ChatPageModal {
  SHOW_VOICE_SELECION_MODAL,
  SHOW_VOICE_UPGRADE_MODAL,
  SHOW_SHARE,
  SHOW_MODEL_SETTINGS,
  SHOW_BLOCK_MODAL,
  UPDATE_CLONE_TITLE_MODAL,
  CONVERSATION_MEMORY_MODAL,
  CHANGE_PERSONA_CONFIRMATION_MODAL,
  CLONE_CONVERSATION_MODAL,
  CHATBOT_RATING_MODAL,
  SHOW_MODEL_SELECT_MODAL,
  SHOW_AUTO_RESPONSE_UPGRADE_MODAL,
}
export enum AlertBubbleVariant {
  INVALID_ACCESS = "invalidAccess",
  BLOCKED_BOT_CREATOR = "blockedBotCreator",
}

export type AlertBubbleProps = {
  error: AlertBubbleVariant | string;
  invalidUrlError?: { message: string } | null;
  character: {
    creator_user_id?: string;
    creator_username?: string;
  };
};
